module.exports = __webpack_public_path__ + "img/4.863766d6.png";